import {
  HttpRequest,
  OrderAppliedRefundOptionsItem,
  OrderCancelAndRefundData,
  OrderRefundEventLog,
  OrderRefundMethodOption,
  OrderRefundNotificationData,
} from '@dapi/sdk';
import {
  amopPaidAmount,
  amopRefundAmounts,
  cardRefundAmount,
  cardRefundAmountWithObfees,
  milesPaymentTransactionsZeroMiles,
  mockPenaltyDetail,
  multipleVoucherTransactionAfterCancellation,
  multipleVoucherWithCCTransaction,
  paidAmountWithMiles,
  paidAmountWithZeroMilesWithoutCancellation,
  paymentDetails,
  paypalPaymentTransactions,
  refundAmounts,
  refundAmountsWithMiles,
  refundAmountsWithMilesZeroWithoutCancellation,
  traveler,
  traveler2,
  traveler3,
  usedAmountWithMiles,
  usedAmountWithZeroMiles,
  voucherPaidAmount,
  voucherPaidAmountWithMultipleVouchers,
  voucherPaymentTransactions,
  voucherRefundAmounts,
  voucherRefundAmountsWithMultipleVouchers,
  voucherWithCCPaidAmount,
  voucherWithCCPenaltyAmount,
  voucherWithCCRefundAmounts,
  zeroAmountInSek,
} from '../dictionaries';
import {
  orderForSingleBoundDisrupted,
  orderMockEligibleToRefund,
  orderMockEligibleToRefundUsingAmop,
} from './refactored-mock-order';

export const updatedOrderLink: HttpRequest = {
  href: 'https://test.airlines.api.amadeus.com/1ASIUAIREY0RSRU/v2/purchase/orders/VP5FQ7?lastName=Dobbs',
  rel: 'updatedOrder'
};

export const createdOrderLink: HttpRequest = {
  href: 'https://test.airlines.api.amadeus.com/1ASIUAIREY0RSRU/v2/purchase/orders/VQU6UW?lastName=DOBBS',
  rel: 'createdOrder'
};

export const refundMethodOptions: OrderRefundMethodOption = {
  id: '6072160342328-DEFAULT',
  paymentDetails: [paymentDetails]
};

export const submission: OrderRefundEventLog = {
  triggerEventName: 'sent'
};
export const refundNotification: OrderRefundNotificationData = {
  contactIds: ['OT13'],
  submission: submission
};
export const refundOption: OrderAppliedRefundOptionsItem = {
  documentType: 'eticket',
  paymentDetails: [paymentDetails],
  refundAmounts: refundAmounts,
  refundNotifications: [refundNotification],
  status: 'refunded',
  travelDocumentId: '6072160342328',
  travelerIds: ['TRAVELER-2-MOCK']
};

export const orderCancelAndRefund: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [refundOption, {
    ...refundOption,
    travelerIds: ['TRAVELER-1-MOCK']
  }, {
    ...refundOption,
    travelerIds: [traveler.id]
  }]
};

export const orderCancelAndRefundTypeInvoluntary: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [{
    ...refundOption,
    travelerIds: [traveler.id],
    refundType: 'involuntary',
    paymentDetails: undefined,
    refundAmounts: undefined,
    refundNotifications: undefined,
    status: 'pendingManualRefund'
  }]
};

export const orderCancelAndRefundUsingAmop: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [{
    ...refundOption,
    travelerIds: [traveler.id],
    paidAmount: amopPaidAmount,
    paymentDetails: paypalPaymentTransactions,
    refundAmounts: amopRefundAmounts,
    travelDocumentId: '1172457148333',
    usedAmount: {
      ...amopPaidAmount,
      taxes: undefined
    }
  }]
};

export const orderCancelAndRefundUsingMultipleVoucherWithCC: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [{
    ...refundOption,
    travelerIds: [traveler.id],
    paidAmount: voucherWithCCPaidAmount,
    paymentDetails: multipleVoucherWithCCTransaction,
    refundAmounts: voucherWithCCRefundAmounts,
    penalty: voucherWithCCPenaltyAmount,
    travelDocumentId: '1172457148333',
    usedAmount: {
      ...amopPaidAmount,
      taxes: undefined
    }
  }]
};

export const orderCancelAndRefundUsingMultipleVoucher: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [{
    ...refundOption,
    travelerIds: [traveler.id],
    paidAmount: voucherPaidAmountWithMultipleVouchers,
    paymentDetails: multipleVoucherTransactionAfterCancellation,
    refundAmounts: voucherRefundAmountsWithMultipleVouchers,
    travelDocumentId: '1172457148333',
    usedAmount: {
      ...amopPaidAmount,
      taxes: undefined
    }
  }]
};

export const orderCancelAndRefundUsingVoucher: OrderCancelAndRefundData = {
  orderId: 'UM8VXN',
  refundOptions: [{
    ...refundOption,
    travelerIds: [traveler.id],
    paidAmount: voucherPaidAmount,
    paymentDetails: voucherPaymentTransactions,
    refundAmounts: voucherRefundAmounts,
    travelDocumentId: '1172457148333',
    usedAmount: {
      ...voucherPaidAmount,
      taxes: undefined
    }
  }]
};

export const orderCancelAndRefundWithMiles: OrderCancelAndRefundData = {
  orderId: orderMockEligibleToRefund.id,
  refundOptions: [{
    travelDocumentId: '2202204070136',
    documentType: 'eticket',
    travelerIds: [traveler.id],
    status: 'refunded',
    refundAmounts: refundAmountsWithMiles,
    paidAmount: paidAmountWithMiles,
    usedAmount: usedAmountWithMiles,
    penalty: {
      ...zeroAmountInSek,
      value: 17_246
    },
    penaltyDetail: mockPenaltyDetail,
    penaltyDocumentId: '0144266140971'
  }]
};

export const orderCancelAndRefundWithMilesWithoutCancellation: OrderCancelAndRefundData = {
  orderId: orderMockEligibleToRefund.id,
  refundOptions: [{
    travelDocumentId: '2202204070136',
    documentType: 'eticket',
    travelerIds: [traveler.id],
    status: 'refunded',
    refundAmounts: refundAmountsWithMilesZeroWithoutCancellation,
    paidAmount: paidAmountWithZeroMilesWithoutCancellation,
    usedAmount: usedAmountWithZeroMiles,
    paymentDetails: milesPaymentTransactionsZeroMiles,
    refundNotifications: [refundNotification]
  }]
};

export const orderCancelAndRefundWithCardInvoluntaryFlow: OrderCancelAndRefundData = {
  orderId: orderMockEligibleToRefundUsingAmop.id,
  refundOptions: [{
    documentType: 'eticket',
    refundAmounts: cardRefundAmount,
    status: 'refunded',
    travelDocumentId: '1172457148333',
    travelerIds: [traveler.id]
  },
  {
    documentType: 'eticket',
    refundAmounts: cardRefundAmount,
    status: 'refunded',
    travelDocumentId: '1172457148334',
    travelerIds: [traveler2.id]
  },
  {
    documentType: 'eticket',
    refundAmounts: {
      ...cardRefundAmount,
      totalTaxes: {
        ...cardRefundAmount.totalTaxes,
        value: 1768
      },
      base: {
        ...cardRefundAmount.base,
        value: 9445
      },
      total: {
        ...cardRefundAmount.total,
        value: 11_213
      }
    },
    status: 'refunded',
    travelDocumentId: '1172457148335',
    travelerIds: [traveler3.id]
  }]
};

export const cancelAndRefundOrderMockOutboundDisruptedRefundable: OrderCancelAndRefundData = {
  orderId: orderForSingleBoundDisrupted.id,
  refundOptions: [
    {
      travelDocumentId: '1052467303580',
      documentType: 'eticket',
      travelerIds: [traveler.id],
      status: 'refunded',
      refundAmounts: cardRefundAmountWithObfees
    },
    {
      travelDocumentId: '1052467303579',
      documentType: 'eticket',
      travelerIds: [traveler2.id],
      status: 'refunded',
      refundAmounts: cardRefundAmountWithObfees
    }
  ]
};
